import { GeoFeatureBase, GeoFeatureInterface } from "./geo-features";

export interface PointFeatureInterface extends GeoFeatureInterface {
  geometry: {
      type?: string;
      coordinates: [number, number];
  }
}

export interface PointFeaturesInterface {
    type: string;
    features: PointFeatureInterface[];
}

export class PointFeature extends GeoFeatureBase {
  override geometryType: string = "Point";
}
